import React, { useEffect, useState } from 'react';

// Muted autoplay loop for the hero figure. SSR and prefers-reduced-motion render the poster only.
const HeroVideo = ({ item }) => {
  const base = `/media/hero/${item.video}`;
  const posterLg = `${base}-poster.jpg`;
  const posterSm = `${base}-poster-sm.jpg`;
  const [motion, setMotion] = useState(false);
  const [poster, setPoster] = useState(posterLg);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setMotion(!mq.matches);
    if (window.matchMedia('(max-width: 860px)').matches) setPoster(posterSm);
    const on = (e) => setMotion(!e.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  return (
    <figure className="gf-figure">
      <div className="gf-img gf-hero-media">
        {motion ? (
          <video autoPlay muted loop playsInline preload="auto" poster={poster} aria-label={item.alt || item.caption}>
            <source src={`${base}.webm`} type="video/webm" />
            <source src={`${base}.mp4`} type="video/mp4" />
          </video>
        ) : (
          <picture>
            <source media="(max-width: 860px)" srcSet={posterSm} />
            <img src={posterLg} alt={item.alt || item.caption || ''} />
          </picture>
        )}
      </div>
      {item.caption && <figcaption>{item.caption}</figcaption>}
    </figure>
  );
};
export default HeroVideo;
